import { UPDATE_PARAMGROUP, UPDATE_PARAMGROUP_SUCCESSFUL, UPDATE_PARAMGROUP_FAILED } from './actionTypes';

export const updatePararamGroup = (paramGroup,user ,history) => {
    return {
        type: UPDATE_PARAMGROUP,
        payload: { paramGroup,user, history }
    }
}

export const updatePararamGroupSuccessful = (msg) => {
    return {
        type: UPDATE_PARAMGROUP_SUCCESSFUL,
        payload: msg
    }
}

export const updatePararamGroupFailed = (msg) => {
    return {
        type: UPDATE_PARAMGROUP_FAILED,
        payload: msg
    }
}
